export const AreaSizeEnum = [
  {
    key: 1,
    value: '0-500',
  },
  {
    key: 2,
    value: '500-750',
  },
  {
    key: 3,
    value: '750-1000',
  },
  {
    key: 4,
    value: '1000-1250',
  },
  {
    key: 5,
    value: '1250-1500',
  },
  {
    key: 6,
    value: '1500-2000',
  },
  {
    key: 7,
    value: '2000-5000',
  },
  {
    key: 8,
    value: '5000+',
  },
];
